import styled, { css } from 'styled-components';

export const InfoButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-left: 6px;
  padding: 0;
  border: 0;
  background: transparent;
  border-radius: 50%;
  cursor: help;
  vertical-align: middle;
  -webkit-tap-highlight-color: transparent;
  opacity: 0.55;
  transition: color ${({ theme: { motion } }) => motion?.duration?.fast ?? '120ms'},
    opacity ${({ theme: { motion } }) => motion?.duration?.fast ?? '120ms'};

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  ${({ theme: { colors = {} } }) => css`
    color: color-mix(
      in oklab,
      ${colors.onSurfaceVariant ?? '#C7C4D7'} 55%,
      transparent
    );
    &:hover,
    &:focus-visible {
      color: ${colors.onSurfaceVariant ?? '#C7C4D7'};
      opacity: 1;
    }
  `}

  & > svg,
  & > .material-symbols-rounded {
    font-size: 13px;
    width: 13px;
    height: 13px;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme: { colors = {} } }) => colors.primary ?? '#C1C1FF'};
    outline-offset: 2px;
  }
`;
